module.exports = __webpack_public_path__ + "img/img 4@2x.10709d2b.png";